import axios from '../../axios'

export default {
  getOrganisations: function () {
    return axios.get('organisations')
  },
  getOrganisation: function (organisationId) {
    return axios.get('organisations/' + organisationId)
  },
  editOrganisation: function (organisationId, organisation) {
    return axios.put('organisations/' + organisationId, organisation)
  }
}



// WEBPACK FOOTER //
// ./src/services/api/OrganisationsApi.js